import React, { useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/root.css";
import "../styles/pages.css";
import aboutImg from "../assets/images/anisija/anisija-logo.svg";
import euLogo from "../assets/images/partners/Eu.png";
import euMkLogo from "../assets/images/partners/EUzaTebe.png";
import grcLogo from "../assets/images/partners/GragjanskiResursenCentar.png";
import socioLogo from "../assets/images/partners/Socio.png";
import { useLocale } from "../context/LocaleContext";

const PARTNERS = [
  { name: "European Union", logo: euLogo },
  { name: "EU Support for Civil Resource Centre", logo: euMkLogo },
  { name: "Граѓански ресурсен центар", logo: grcLogo },
  { name: "Здружение СОЦИО Гостивар", logo: socioLogo },
];

function About() {
  const { t } = useLocale();
  const revealRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const addRef = (el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
    }
  };

  return (
    <div>
      <Navbar />

      {/* Page Header */}
      <div className="page-hero">
        <div className="page-hero-inner">
          <span className="page-hero-eyebrow">Anisija</span>
          <h1 className="page-hero-title">{t.about.headline}</h1>
          <div className="page-hero-line" />
        </div>
      </div>

      <div className="page-container">
        {/* About Content */}
        <section className="about-section" ref={addRef}>
          <div className="about-content-wrap reveal-up">
            <div className="about-body">
              {t.about.content.map((paragraph, index) => (
                <p key={index} className="about-paragraph">{paragraph}</p>
              ))}
            </div>
            <div className="about-logo-wrap">
              <img
                src={aboutImg}
                alt={t.about.imageAlt}
                className="about-logo-img"
              />
            </div>
          </div>
        </section>

        {/* Partners */}
        <section className="partners-section" ref={addRef}>
          <div className="reveal-up">
            <h2 className="partners-title">{t.about.partnersHeading}</h2>
            <div className="partners-line" />
          </div>
          <div className="partners-grid" ref={addRef}>
            {PARTNERS.map((partner, i) => (
              <div
                className="partner-item reveal-up"
                key={partner.name}
                style={{ "--delay": `${i * 100}ms` }}
              >
                <img src={partner.logo} alt={partner.name} />
              </div>
            ))}
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default About;
